"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertOfferToBannerData = exports.isNil = void 0;
function isNil(x) {
    return x === null || x === undefined;
}
exports.isNil = isNil;
function getDynamicParams(newDynamicParams) {
    var domainName = newDynamicParams.domainName, siteName = newDynamicParams.siteName, userEmail = newDynamicParams.userEmail, saleEndDate = newDynamicParams.saleEndDate;
    var dynamicParams = {};
    if (!isNil(domainName)) {
        dynamicParams.domainName = domainName;
    }
    if (!isNil(siteName)) {
        dynamicParams.siteName = siteName;
    }
    if (!isNil(userEmail)) {
        dynamicParams.userEmail = userEmail;
    }
    if (!isNil(saleEndDate)) {
        dynamicParams.saleEndDate = saleEndDate;
    }
    return dynamicParams;
}
function convertOfferToBannerData(offer) {
    var offerDynamicParams = offer.asset.dynamicParams || {};
    var dynamicParams = getDynamicParams(offerDynamicParams);
    var payload = JSON.parse(offer.asset.payloadJson);
    var bannerData = {
        bannerPosition: offer.realEstateId,
        bannerId: payload.templateId,
        bannerTemplate: payload.template,
        lightboxTriggers: payload.triggers,
        lightboxGuid: offer.offerGuid,
        dynamicParams: dynamicParams,
        saleType: offerDynamicParams.SALE_TYPE,
        isPremium: undefined,
        daysLeft: !isNil(offerDynamicParams.DAYS_LEFT)
            ? parseInt(offerDynamicParams.DAYS_LEFT, 10)
            : undefined,
    };
    return bannerData;
}
exports.convertOfferToBannerData = convertOfferToBannerData;
//# sourceMappingURL=toDomain.js.map